function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 6.504,
  width: 8,
  height: 60
});

const SvgColumn = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  x: "0px",
  y: "0px",
  viewBox: "0 0 20.969 20.969",
  width: 6,
  height: 35,
  style: {
    marginTop: "-4px",
    fill: "currentColor"
  },
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColumn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/column.a19e6d9a.svg";
export { ForwardRef as ReactComponent };